import { render, staticRenderFns } from "./order-receiver.vue?vue&type=template&id=274f2c65&"
import script from "./order-receiver.vue?vue&type=script&lang=js&"
export * from "./order-receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports